import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSignup } from '@context/SignupContext';
import { toast } from 'react-toastify';
const ProtectedSignupRoute = ({ children }) => {
    const { termsAccepted, verified, isLoading } = useSignup();
    const location = useLocation();

  useEffect(() => {
    if (!isLoading) {
      if (!termsAccepted) {
        toast.info('회원가입 약관에 동의해야 합니다.');
      } 
      // else if (termsAccepted && !verified) {
      //   toast.info('본인 인증을 완료해야 합니다.');
      // }
    }
  }, [termsAccepted, verified, isLoading]);

  if (isLoading) {
    return <div>로딩 중...</div>; 
  }

  if (!termsAccepted) {
    return <Navigate to="/terms" replace state={{ from: location }} />;
  }

  // if (termsAccepted && !verified) {
  //   return <Navigate to="/verify" replace state={{ from: location }} />;
  // }

  return children;
};

export default ProtectedSignupRoute;
